resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function Instagram() {

    this._nextUrl = null;
    this._callback = null;

    this.constructor = function() {};

    this.retrieveNextImages = function(count, callback) {
        // Set callback
        if (callback)
            this._callback = callback;

        // Set parameters
        var params = {
            url: "https://api.instagram.com/v1/users/288821076/media/recent/",
            dataType: 'jsonp',
            crossDomain: true,
            data: {
                "count": count,
                "client_id": "e948c5331686475abe00827d6a1d193e"
            },
            success: $.proxy(this._onDataSuccess, this),
            error: $.proxy(this._onDataFailure, this)
        };

        // Set url to next url, if applicable
        if (this._nextUrl != null) {
            params.url = this._nextUrl;
        }

        // Request images
        $.ajax(params);
    };

    this.resetStream = function() {
        // Reset next URL to start from beginning
        this._nextUrl = null;
    };

    this._onDataSuccess = function(data) {
        this._nextUrl = encodeURI(data.pagination.next_url);
        if (this._callback != null)
            this._callback(data.data);
    };

    this._onDataFailure = function(error) {
        if (this._callback != null)
            this._callback(error);
        else
            console.error(error);
    };

    this.constructor();
}